import { BusinessUnitAddressServiceBase } from './business-unit-address.service.base';
import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { ENVIRONMENT } from '@scisys-uim/uim-common';


@Injectable({
  providedIn: 'root'
})
export class BusinessUnitAddressService extends BusinessUnitAddressServiceBase {
  constructor(http: HttpClient, @Inject(ENVIRONMENT) environment: any) {
    super(http, environment);
  }

}



